import React, { useRef } from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button/button';

interface IProps extends ButtonProps {
  throttleTime?: number;
}

const Index: React.FC<IProps> = (props) => {
  const statusRef = useRef(false);
  const { onClick, throttleTime, ...extra } = props;

  // 按钮点击回调
  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    if (statusRef.current) return;
    statusRef.current = true;
    onClick(event);
    setTimeout(() => {
      statusRef.current = false;
    }, throttleTime || 500);
  };

  return <Button {...extra} onClick={handleButtonClick} />;
};

export default Index;
